import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import VideoGrid from "../Components/VideoGrid";
import { imagesApi, pre, videosApi } from "../api/api";
import axios from "axios";
import Layout from "../Components/Layout";
import Loader from "../Components/Loader";
import Carousel from "../Components/Carousel";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from 'js-cookie';

const HomeRoute = () => {
  const navigate = useNavigate();
  const [number, setNumber] = useState("");
  const [videos, setVideos] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  // const location = useLocation();
  // const msisdnn = new URLSearchParams(location.search).get("msisdn");

  // useEffect(() => {
  //   navigate('/subscribe')
  //   // setMsisdn(msisdnn);
  // }, []);
const msisdn=Cookies.get('kidszonepro_user')
console.log("MSISDN IN COOKIES",msisdn)

const checkUser = async () => {

  let formattedMsisdn = msisdn;

 
  if (typeof formattedMsisdn !== 'string') {
    formattedMsisdn = String(formattedMsisdn);
  }

  if (formattedMsisdn.substring(0, 2) !== '94') {
    if (formattedMsisdn[0] === '0') {
      formattedMsisdn = formattedMsisdn.slice(1);
    }
    formattedMsisdn = '94' + formattedMsisdn;
  }

  console.log(formattedMsisdn, "Formatted Number");
  console.log(formattedMsisdn, "Number-------------------");

  try {
    const res = await axios.get('/checkuser', {
      params: {
        msisdn: formattedMsisdn,
        service: "Kidszonepro"
      }
    });

    console.log("RESPONSE",res.data)
    // If the status is 0 or 3, remove the cookie, warn the user, and navigate away.
    if (res.data.status == 0 || res.data.status == 3) {
      Cookies.remove('kidszonepro_user');
      toast.warn("Subscription Expired!!");
      setTimeout(() => {
        navigate('/');
      }, 2000);
    }
    // For all other statuses, do nothing (stay on the page).
    setNumber('');
  } catch (err) {
    console.log(err);
  }
};

  


  const fetchDataFromBackend = async () => {
    try {
      const res = await axios.get(`${pre}/${videosApi}`);
      const res2 = await axios.get(`${pre}/${imagesApi}`);
      setImages(res2?.data);
      setVideos(res?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error?.message);
    }
  };



  useEffect(() => {
    axios.get('/getheaders')
    .then(response => {
      const data = response.data;
      console.log("RESPONSE Data", data)
      if (data.status == '1') {
        Cookies.set('gameofyy_user', data.msisdn, { expires: 1 });
        Cookies.set('status', data.status, { expires: 1 });
      }
      else if(data.status=='0'){
        Cookies.set('status','0', { expires: 1 });
      }
      else{
        Cookies.set('status','0', { expires: 1 });
      }
    })
    .catch(error => console.error("Error fetching data:", error));
}, []);

  useEffect(()=>{
    // checkUser()
    fetchDataFromBackend();
  },[])

 

  

  return (
    <>
      <Navbar />
      <Layout>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="py-4">
              <Carousel images={images} />
              {/* <Carousel images={images} msisdn={msisdn} /> */}
            </div>
            <div className="pb-4">
              {/* <VideoGrid videos={videos} msisdn={msisdn} /> */}
              <VideoGrid videos={videos} />
            </div>
          </>
        )}
      </Layout>
    </>
  );
};

export default HomeRoute;
